export default "/images/bell.svg?6657646fcc131f5047375e9f59bb52b2";